angular.module("app").controller("SkillGamesPageController", [
    '$scope',
    '$cookies',
    '$window',
    '$templateRequest',
    '$interpolate',
    '$timeout',
    '$controller',
    'skillGamesService',
    'errorHandler',
    'logger',
    'settingsService',
    'preloadedProperties',
    'deepCompare',
    'casinoGameService',
    'backgroundAttachment',
    'skillGamesPageDefaults',
    'Utils',
    function ($scope, $cookies, $window, $templateRequest, $interpolate, $timeout, $controller, skillGamesService, errorHandler, logger, settingsService,  preloadedProperties, deepCompare, casinoGameService, backgroundAttachment, skillGamesPageDefaults, Utils) {
        var dependency = {
            '$scope': $scope,
            '$cookies': $cookies,
            '$window': $window,
            '$templateRequest': $templateRequest,
            '$interpolate': $interpolate,
            '$timout': $timeout,
            'preloadedProviders': null,
            'service': skillGamesService,
            'errorHandler': errorHandler,
            'logger': logger,
            'settingsService': settingsService,
            'preloadedProperties': preloadedProperties,
            'deepCompare': deepCompare,
            'casinoGameService': casinoGameService,
            'backgroundAttachment': backgroundAttachment,
            'builderPageDefaults': skillGamesPageDefaults,
            'Utils': Utils
        };

        $controller('PageBuilderController', dependency);



    }
]);
